<template>
	<div
		id="root-module"
		:style="rootStyle"
	>
		<slot/>

		<div
			v-if="!heineken"
			class="footer"
		>
			<div
				v-if="dModule.data.showTerms"
				class="footer__item text-center"
			>
				<terms-dialog
					ref="termsDialog"
					:title="dModule.data.termsLabel"
					:terms="dModule.data.termsText"
				/>
			</div>

			<div
				v-if="dModule.data.showPrivacyPolicy"
				class="footer__item text-center"
			>
				<terms-dialog
					ref="termsDialog"
					:title="dModule.data.privacyPolicyLabel"
					:terms="dModule.data.privacyPolicyText"
				/>
			</div>

			<div
				v-if="$store.getters.pageId == 2695 || $store.getters.pageId == 3194 || $store.getters.pageId == 4414"
				class="footer__item text-center"
			>
				<terms-dialog
					title="Privacy Notice"
					:terms="privacyNotice"
				/>
			</div>

			<div
				v-if="dModule.data.poweredBy"
				class="footer__item text-center"
			>
				<small>
					{{ $t("powered-by") }}
					<a
						class="blank-href"
						:href="dModule.data.poweredByLink"
						target="_blank"
					>
						{{ dModule.data.poweredBy }}
					</a>
				</small>
			</div>
		</div>

		<!-- Coca-cola invalid loyalty user -->
		<cc-invalid-id-dialog
			v-if="cocaCola"
			ref="ccInvalidId"
		/>
	</div>
</template>

<script>
import { EventBus } from "@/event-bus.js";

import TermsDialog from "@/components/dialogs/TermsDialog.vue";
import CcInvalidIdDialog from "@/components/dialogs/CcInvalidIdDialog.vue";

// eslint-disable-next-line
import privacyNotice from "raw-loader!@/assets/privacy.txt";

export default {
	name: "RootModule",
	props: {
		data: Object,
	},
	components: {
		TermsDialog,
		CcInvalidIdDialog,
	},
	data() {
		return {
			dModule: this.data,

			privacyNotice: privacyNotice,
		};
	},
	methods: {
		handleCocaCola() {
			let param = this.getParameterByName("id");

			// No parameter
			if (!param) this.$refs.ccInvalidId.open();
		},
		getParameterByName(name, url = window.location.href) {
			//eslint-disable-next-line
            name = name.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
			var results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return "";
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		},
	},
	mounted() {
		EventBus.$on("open-terms", () => {
			this.$refs.termsDialog.open();
		});

		// Coca-cola receipt upload
		if (this.cocaCola) this.handleCocaCola();
	},
	computed: {
		rootStyle() {
			return {
				backgroundColor: this.dModule.color,
				color: this.dModule.layout.textColor,
			};
		},
		cocaCola() {
			// "GhkzLlTHBZ" -> PBX Packageless
			// "rNpY46wKGg" -> Capri-Sun 2022
			const campaigns = ["GhkzLlTHBZ", "rNpY46wKGg"];

			return campaigns.includes(this.$store.getters.code);
		},
		heineken() {
			const campaigns = ["mluZQZQxE4"];

			return campaigns.includes(this.$store.getters.code);
		},
	},
};
</script>

<style scoped>
#root-module {
    width: 100%;
    height: 100%;
}

.footer__item {
    height: 20px;
}
</style>
